<template>
    <div class="cst-survey-content">
        <transition :name="transition" mode="out-in">
            <card-survey-done v-if="isSurveyFinished && (!card || card.type=='card-question' || card.type=='card-public-question')" :card="card"></card-survey-done>
            <component v-else-if="card" :is="card.type" v-bind:key="card.id" v-bind:content="card.content" v-bind:events="card.events"></component>
        </transition>
    </div>
</template>

<script>
    import CardQuestion from './CardQuestion'
    import CardPublicQuestion from './CardPublicQuestion'
    import CardThanks from './CardThanks'
    import CardCustomerData from './CardCustomerData'
    import CardQuestionSelector from './CardQuestionSelector'
    import CardFinished from './CardFinished'
    import CardHolidayCheck from './CardHolidayCheck'
    import CardHcSelector from './CardHcSelector'
    import CardSurveyDone from './CardSurveyDone'
    
    export default {
      props: [ 'card' ],
      components: {
        CardQuestion, CardPublicQuestion, CardThanks, CardCustomerData, CardQuestionSelector, CardFinished, CardHolidayCheck, CardHcSelector, CardSurveyDone
      },
      computed: {
        transition: function () {
          return this.$store.state.transition
        },
        isSurveyFinished: function () {
          return this.$store.state.is_survey_finished
        }
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-survey-content {
        color: #5c5c5c;  
        padding: 1em 4.5em;
        //padding-bottom: 0;  
        flex-grow: 10;
        display: flex;
    }
    .flip-enter-active {
        transition: all .2s cubic-bezier(0.55, 0.085, 0.68, 0.53); //ease-in-quad
        border-color: green;
    }

    .flip-leave-active {
        transition: all .25s cubic-bezier(0.25, 0.46, 0.45, 0.94); //ease-out-quad
        border-color: red;
    }

    .flip-enter, .flip-leave-to {
        transform: scaleY(0) translateZ(0);
    }

    .slide-leave-active,
    .slide-enter-active {
    transition: 0.2s;
    }
    .slide-enter {
    transform: translate(100%, 0);
    }
    .slide-leave-to {
    transform: translate(-100%, 0);
    }


    .reverseslide-leave-active,
    .reverseslide-enter-active {
    transition: 0.2s;
    }
    .reverseslide-enter {
    transform: translate(-100%, 0);
    }
    .reverseslide-leave-to {
    transform: translate(100%, 0);
    }

    @media (max-width: 1100px) {
        .cst-survey-content {
            padding: 1em;
            padding-bottom: 0;
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/AppContent.vue